import Text from './Text';
export default Text;
//# sourceMappingURL=index.js.map